import { useRegisterSW } from 'virtual:pwa-register/react';

import { scheduleUpdateCheck } from './schedule-update-check';

export interface PwaUpdate {
  needRefresh: boolean;
  applyUpdate: () => void;
}

const UPDATE_CHECK_INTERVAL_MS = 30 * 60_000;

/** Thin wrapper over the plugin's virtual module so tests can replace it. */
export function usePwaUpdate(): PwaUpdate {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (registration !== undefined) {
        scheduleUpdateCheck(registration, UPDATE_CHECK_INTERVAL_MS);
      }
    },
  });

  return { needRefresh, applyUpdate: () => void updateServiceWorker(true) };
}
